// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1WNlV","content":"Consent_content__2zgKw","footer":"Consent_footer__1HRt7"};